var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 14.75C8.98579 14.75 8.65 15.0858 8.65 15.5C8.65 15.9142 8.98579 16.25 9.4 16.25V14.75ZM20.6 16.25C21.0142 16.25 21.35 15.9142 21.35 15.5C21.35 15.0858 21.0142 14.75 20.6 14.75V16.25ZM15.75 9.9C15.75 9.48579 15.4142 9.15 15 9.15C14.5858 9.15 14.25 9.48579 14.25 9.9H15.75ZM14.25 21.1C14.25 21.5142 14.5858 21.85 15 21.85C15.4142 21.85 15.75 21.5142 15.75 21.1H14.25ZM28.25 15.5C28.25 22.8178 22.3178 28.75 15 28.75V30.25C23.1462 30.25 29.75 23.6462 29.75 15.5H28.25ZM15 28.75C7.68223 28.75 1.75 22.8178 1.75 15.5H0.25C0.25 23.6462 6.8538 30.25 15 30.25V28.75ZM1.75 15.5C1.75 8.18223 7.68223 2.25 15 2.25V0.75C6.8538 0.75 0.25 7.3538 0.25 15.5H1.75ZM15 2.25C22.3178 2.25 28.25 8.18223 28.25 15.5H29.75C29.75 7.3538 23.1462 0.75 15 0.75V2.25ZM9.4 16.25H20.6V14.75H9.4V16.25ZM14.25 9.9V21.1H15.75V9.9H14.25Z",
    fill: "#8B53FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.fe3ab47c18aecba12ab4cd54bd3019c8.svg";
export { ForwardRef as ReactComponent };